module.exports = __webpack_public_path__ + "static/media/scroll-top.99697cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/new/scroll-top.png
// module id = 725
// module chunks = 0